import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, Link } from 'react-router-dom';
import { version } from '../package.json';

import './App.scss';

import { Button } from '@rmwc/button';
import { CircularProgress } from '@rmwc/circular-progress';

import AuthService from './services/authService';
import StorageService from './services/storageService';

import Login from './components/login';
import Logout from './components/logout';
import Callback from './components/callback';
import Main from './components/main';
import DashboardExcelExport from './components/dashboardexcelexport';
import CTCTimingExcelExport from './components/ctctimingexcelexport';
import OPNRExcelExport from './components/opnrexcelexport';

var datasetToExcelExport = null;

function doLogout() {
  if (window.confirm('Are you sure you want to logout?')) {
    AuthService.logout();
    window.location = process.env.PUBLIC_URL || '/';
  }
}

function LogoutButton(props) {

  function doTheExport() {
    // Silly hack to get the ExcelFile component to "reset" so download works more than once
    setDoExport(true);
    window.setTimeout(() => {
      setDoExport(false);
    }, 1000)
  };

  const [doExport, setDoExport] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setIsSaving(StorageService.pendingUpdates());
    }, 100);
    return () => clearInterval(timer);
  }, []);

  let savingElement = null;

  if (props.loggedin) {
    let excelFileElement = null;
    if (doExport) {
      if (datasetToExcelExport?.type === 'opnr') {
        excelFileElement = <OPNRExcelExport data={datasetToExcelExport} />
      }
      else {
        if (datasetToExcelExport.monthsData) {
          excelFileElement = <CTCTimingExcelExport data={datasetToExcelExport} />
        }
        else {
          excelFileElement = <DashboardExcelExport data={datasetToExcelExport} />
        }
      }
    }

    if (isSaving) {
      savingElement = <><CircularProgress size="small" /><div className="is-saving">SAVING...</div></>;
    }
    else {
      savingElement = null;
    }

    return <div className="logout-button">
        { excelFileElement }  
        { savingElement }    
        <Button className="outer-button-spacing" label="Export" icon="cloud_download" raised onClick={() => doTheExport()} />
        <Button className="outer-button-spacing" label="Print" icon="print" raised onClick={() => window.print()} />
        <Button label="Logout" icon="logout" unelevated onClick={doLogout} />
      </div>
  }

  return null;
}

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(AuthService.isLoggedIn());

  return (
    <div className="App">

    <Router basename={process.env.PUBLIC_URL}>
      <header className="no-print App-header">
        <Link to="/costs">
          <img src={process.env.PUBLIC_URL + '/logo.jpg'} className="App-logo" alt="logo" />
          <div>FATA PM Dashboard<span style={{ fontSize: 'xx-small', marginLeft: '5px'}}>v{version}</span></div>
        </Link>
        <LogoutButton loggedin={isLoggedIn} />
      </header>

      <div className="Main-content">
          <Switch>
            <Route path="/login" render={() => <Login onLogin={() => setIsLoggedIn(true)} />} />
            <Route path="/callback" render={() => <Callback onLogin={() => setIsLoggedIn(true)} />} />
            <Route path="/logout" component={Logout} />
            <Route path="/" render={() => <Main onExportDataset={(ds) => { datasetToExcelExport = ds; } }/>} />
          </Switch>
      </div>

      </Router>
    </div>
  );
}

export default App;
